"use strict";

exports.__esModule = true;
exports.tooltipContext = void 0;

var _react = require("react");

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
const tooltipContext = (0, _react.createContext)();
exports.tooltipContext = tooltipContext;